import React from 'react';
import CopyToClipboard from 'components/ui/copyToClipboard/CopyToClipboard';
import { addTranslation, IntlProps } from 'decorators/addTranslation';

interface Props extends IntlProps {
  content: string;
}

class AdditionalInfo extends React.Component<Props> {
  render(): JSX.Element {
    let content;
    try {
      content = JSON.stringify(JSON.parse(this.props.content), null, 4);
    } catch (e) {
      console.warn(e);
      content = this.props.content;
    }

    return (
      <div className='relative mx-4 mt-2'>
        <CopyToClipboard text={content} customClass='absolute top-4 right-4' />
        <pre className='bg-background-secondary rounded-[8px] p-4 whitespace-pre-wrap'>
          {content}
        </pre>
      </div>
    );
  }
}

export default addTranslation(AdditionalInfo);
